export default "__VITE_ASSET__C7JPR6tZ__"